import { Action } from '@ngrx/store';
import { NotificationActionTypes } from './notification-action-types';
import { INotificationState } from '../models/notification.model';

export class RequestShowNotification implements Action {
  readonly type: NotificationActionTypes.REQUEST_SHOW_NOTIFICATION = NotificationActionTypes.REQUEST_SHOW_NOTIFICATION;

  constructor(public payload: INotificationState) { }
}
